import { useAuthStore } from '~/store/auth';

export default defineNuxtRouteMiddleware(async to => {
  const auth = useAuthStore();

  if (to.fullPath.startsWith('/store/reinstall')) {
    return true;
  }

  // Public self-service developer/partner signup — accessible without authentication.
  // (Still gated behind the DEVELOPER_PLATFORM flag by the parent developer.vue middleware.)
  if (to.path.startsWith('/developer/signup')) {
    return true;
  }

  if (to.path === '/analytics/revenue-calculator' && (to.query.shop || to.query.embedded === '1' || to.query.host)) {
    return true;
  }

  if (!auth.authenticated && !to.fullPath.startsWith('/login')) {
    const skipPaths = ['/claims/todo'];
    const query: Record<string, any> = {};

    // Preserve dri token as top-level query param
    if (to.query.dri) {
      query.dri = to.query.dri;
    }

    if (!skipPaths.includes(to.fullPath)) {
      // Remove dri from redirect path since it's now top-level
      const redirectPath = to.fullPath.replace(/[?&]dri=[^&]+/, '').replace(/\?$/, '');
      query.redirect = encodeURIComponent(redirectPath || '/');
    }

    return navigateTo({ path: '/login', query });
  }

  return true;
});
